/**
 * @generated SignedSource<<ffdd44876a4ce88e9b82aac161024dc8>>
 * @relayHash 678630a9a928ebc4d8b67fb0dc0ae497
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eb60774f0578987201a47de3ab905c8154c05585856f74f3f9137126506fb9e5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RecommendedTabEntryPointRootQuery } from './RecommendedTabEntryPointRootQuery.graphql';

import isForYouNewUsersEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraForYouLandAllNewUsersRelayProvider';
import isJiraFyInvokeAgentExperimentAnalyticsEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraFyInvokeAgentExperimentAnalyticsRelayProvider';
import isJiraFyRecommendedAssignAgentEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraFyRecommendedAssignAgentRelayProvider';
import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';

const node: PreloadableConcreteRequest<RecommendedTabEntryPointRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "eb60774f0578987201a47de3ab905c8154c05585856f74f3f9137126506fb9e5",
    "metadata": {},
    "name": "RecommendedTabEntryPointRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyRecommendedAssignAgentRelayProvider": isJiraFyRecommendedAssignAgentEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraForYouLandAllNewUsersRelayProvider": isForYouNewUsersEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyInvokeAgentExperimentAnalyticsRelayProvider": isJiraFyInvokeAgentExperimentAnalyticsEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
    }
  }
};

export default node;
